/**
 * @name eye-dashed
 * @description Lucide SVG string.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTMuMDU0IDE4Ljk0NmExMSAxMSAwIDAgMS0yLjExIDAiIC8+CiAgPHBhdGggZD0iTTEzLjA1NCA1LjA1NGExMSAxMSAwIDAgMC0yLjExLS4wMDEiIC8+CiAgPHBhdGggZD0iTTE3LjA3MiA2LjI3NGExMSAxMSAwIDAgMSAxLjc1MyAxLjE3MyIgLz4KICA8cGF0aCBkPSJNMTguODI1IDE2LjU1MmExMSAxMSAwIDAgMS0xLjc1MyAxLjE3NCIgLz4KICA8cGF0aCBkPSJNMi41MTQgMTMuMzAzYTExIDExIDAgMCAxLS40NTItLjk1NCAxIDEgMCAwIDEgMC0uNjk3IDExIDExIDAgMCAxIC40NS0uOTU1IiAvPgogIDxwYXRoIGQ9Ik0yMS40ODUgMTAuNjk3YTExIDExIDAgMCAxIC40NTMuOTU1IDEgMSAwIDAgMSAwIC42OTcgMTEgMTEgMCAwIDEtLjQ1My45NTQiIC8+CiAgPHBhdGggZD0iTTUuMTczIDcuNDQ4YTExIDExIDAgMCAxIDEuNzUzLTEuMTc0IiAvPgogIDxwYXRoIGQ9Ik02LjkyNiAxNy43MjZhMTEgMTEgMCAwIDEtMS43NTMtMS4xNzQiIC8+CiAgPGNpcmNsZSBjeD0iMTIiIGN5PSIxMiIgcj0iMyIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/eye-dashed
 * @see https://lucide.dev/guide/packages/lucide-static - Documentation
 *
 * @returns {String}
 *
 */
const EyeDashed: string = `
<svg
  class="lucide lucide-eye-dashed"
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
>
  <path d="M13.054 18.946a11 11 0 0 1-2.11 0" />
  <path d="M13.054 5.054a11 11 0 0 0-2.11-.001" />
  <path d="M17.072 6.274a11 11 0 0 1 1.753 1.173" />
  <path d="M18.825 16.552a11 11 0 0 1-1.753 1.174" />
  <path d="M2.514 13.303a11 11 0 0 1-.452-.954 1 1 0 0 1 0-.697 11 11 0 0 1 .45-.955" />
  <path d="M21.485 10.697a11 11 0 0 1 .453.955 1 1 0 0 1 0 .697 11 11 0 0 1-.453.954" />
  <path d="M5.173 7.448a11 11 0 0 1 1.753-1.174" />
  <path d="M6.926 17.726a11 11 0 0 1-1.753-1.174" />
  <circle cx="12" cy="12" r="3" />
</svg>
`;

export default EyeDashed;
